var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M7.5013 5.24419C6.94554 5.40989 6.41458 5.65843 5.92715 5.98412C4.96786 6.6251 4.22019 7.53614 3.77867 8.60204C3.33716 9.66794 3.22164 10.8408 3.44672 11.9724C3.67181 13.1039 4.22738 14.1433 5.04318 14.9592C5.85899 15.775 6.89839 16.3305 8.02995 16.5556C9.1615 16.7807 10.3344 16.6652 11.4003 16.2237C12.4662 15.7821 13.3772 15.0345 14.0182 14.0752C14.3439 13.5877 14.5924 13.0568 14.7581 12.501H9.58464C8.43405 12.501 7.50131 11.5683 7.50131 10.4177L7.5013 5.24419ZM8.33634 3.38061C8.79374 3.32957 9.16797 3.70746 9.16797 4.16769V10.4177C9.16797 10.6478 9.35452 10.8344 9.58464 10.8344H15.8346C16.2949 10.8344 16.6728 11.2086 16.6217 11.666C16.4891 12.8551 16.0732 13.9996 15.404 15.0011C14.5799 16.2345 13.4085 17.1958 12.0381 17.7635C10.6677 18.3311 9.15965 18.4796 7.70479 18.1902C6.24994 17.9009 4.91357 17.1866 3.86467 16.1377C2.81578 15.0888 2.10147 13.7524 1.81208 12.2975C1.52269 10.8427 1.67122 9.33468 2.23888 7.96424C2.80653 6.59379 3.76783 5.42245 5.0012 4.59834C6.00276 3.92912 7.1472 3.51328 8.33634 3.38061Z",
      "fill": "#07B53B"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M16.4222 7.5007C16.3651 7.30918 16.2981 7.12037 16.2213 6.93505C15.9282 6.22731 15.4985 5.58425 14.9568 5.04258C14.4151 4.5009 13.7721 4.07122 13.0644 3.77807C12.879 3.7013 12.6902 3.63429 12.4987 3.57719V7.5007H16.4222ZM18.2858 8.33574C18.3368 8.79314 17.9589 9.16737 17.4987 9.16737H11.2487C11.0186 9.16737 10.832 8.98082 10.832 8.7507V2.5007C10.832 2.04046 11.2063 1.66258 11.6637 1.71361C12.3631 1.79165 13.0494 1.9679 13.7022 2.23827C14.6121 2.61518 15.4389 3.16762 16.1353 3.86406C16.8318 4.5605 17.3842 5.3873 17.7611 6.29724C18.0315 6.94998 18.2077 7.63633 18.2858 8.33574Z",
      "fill": "#07B53B"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }